import React from 'react';

import { 
  Box, 
  Typography 
} from '@mui/material';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import "./styles.scss";

const CertificationNavigation = ({
  path, 
  currentPage,
  navigate
}) => {
  return (
    <Box className="nav__side-common flex_SBColumn" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification");
          }}>
          <HomeOutlinedIcon />
          <Typography variant='body2'>
            Home Page - Certification
          </Typography>
        </Box>
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/authorities");
          }}>
          <GavelOutlinedIcon />
          <Typography variant='body2'>
            Authorities
          </Typography>
        </Box>
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/dbe");
          }}>
          <ReportProblemOutlinedIcon />
          <Typography variant='body2'>
            DBE
          </Typography>
        </Box>
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/license-batches");
          }}>
          <VpnKeyOutlinedIcon />
          <Typography variant='body2'>
            License Batches
          </Typography>
        </Box>
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/workflow-templates");
          }}>
          <DescriptionOutlinedIcon />
          <Typography variant='body2'>
            Workflow Templates
          </Typography>
        </Box>
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/template-allotments");
          }}>
          <AssignmentIndOutlinedIcon />
          <Typography variant='body2'>
            Template Allotments
          </Typography>
        </Box>
        <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/workflow-template-groups");
          }}>
          <FolderOutlinedIcon />
          <Typography variant='body2'>
            Workflow Template Groups
          </Typography>
        </Box>
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/certification/template-group-allotments");
          }}>
          <GroupsOutlinedIcon />
          <Typography variant='body2'>
            Template Group Allotments
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default CertificationNavigation